import {defineRouting} from "next-intl/routing";
import {LANGUAGE_LIST} from "@/components/constants";

/**
 * next-intl 다국어 라우팅 설정
 * - 지원 locale 목록 정의
 * - 기본 locale 설정
 */
export const routing = defineRouting({
    locales: LANGUAGE_LIST,
    defaultLocale: LANGUAGE_LIST[0],
});